module.exports = __webpack_public_path__ + "media/images/prizes__sidebar--image-bacacc7ef51699b61dff61f7462cbcd9.png";